<template>
    <div class="layout-container floor-sale-container" >
        <div class="mobile-list">
            <div class="mobile-item">
                <h1 class="title">默认坐席列表
                    <el-button class="floatR" icon="el-icon-plus" @click.prevent.stop="openAddSite">新增坐席</el-button>
                </h1>
                <div class="site-list">
                    <div v-if="siteList.length <= 0" class="site-empty">
                        <i class="el-icon-plus add-site" @click.prevent.stop="openAddSite"></i>
                        <span class="desc">还没发现坐席信息哦</span>
                    </div>
                    <div v-else>
                        <div v-for="(data, key) in siteList" :key="key" class="item">
                            <img src="../../../../assets/img/portia.png" class="portia" />
                            <p class="text">{{data.staff_name}}({{data.staff_phone}})</p>
                            <div class="icon-operation-list">
                                <i class="el-icon-edit-outline icon-ope" @click.prevent.stop="editSeat(data, key)"></i>
                                <i class="el-icon-back icon-ope icon-ope-up" v-if="siteList.length > 1"  @click="translatePosition(true, key)"></i>
                                <i class="el-icon-back icon-ope icon-ope-down" v-if="siteList.length > 1"  @click="translatePosition(false, key)"></i>
                                <i class="el-icon-delete icon-ope" @click="deleteArea(key)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile-item">
                <h1 class="title">接听方式</h1>
                <div>
                    <el-tooltip 
                        :class="listenerCheck.id === item.id ? 'item listene-type active' : 'item listene-type'" 
                        placement="top"
                        popper-class="propp"
                        v-for="(item, key) in listener" 
                        :key="key"
                      
                    >
                        <div slot="content">{{item.desc}}</div>
                        <el-button  @click.stop.prevent="listenerCheck = item">{{item.name}}</el-button>
                    </el-tooltip>
                    
                </div>
            </div>
        </div>
        <div class="qudao-list">
            <h1 class="title">推广渠道
                <el-tooltip class="item"  popper-class="propp" effect="dark" content="1. 新增推广渠道后，可复制对应的竞价链接用于推广的竞价投放使用。

  2.为保证推广数据准确，自然渠道不可生成竞价链接，请按推广平台来新增推广渠道，选择竞价链接。" placement="top-start">
                <i class="el-icon-warning"></i>
                </el-tooltip>
                <el-button  class="floatR" icon="el-icon-plus" @click="openChannel" >新增推广渠道</el-button>
            </h1>
            <el-table :data="channelList" style="width: 100%" :highlight-current-row="true" stripe tooltip-effect="dark" ref="channelTable" v-loading="isLoading"
                @selection-change="changeCheckbox"
            >
                <el-table-column  label="ID" prop="id" :sortable="true"></el-table-column>
                <el-table-column  label="推广渠道" prop="channel_name"></el-table-column>
                <el-table-column  label="400号码" prop="hotline_number"></el-table-column>
                <el-table-column  label="400分机号" prop="telephone_number"></el-table-column>
                <el-table-column label="绑定状态" prop="bind_status_name">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.bind_status_name">{{scope.row.bind_status_name}}</span>
                        <span  v-else>待绑定</span>
                    </template>
                </el-table-column>
                <el-table-column  label="更新时间" prop="updated_at"></el-table-column>
                <el-table-column label="操作" width='400'>
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.channel=== 1 && scope.row.hotline_number" @click="handleChannelDelete(scope.$index, scope.row)">解绑400</el-button>
                        <el-button size="mini" v-if="scope.row.channel=== 1 && !scope.row.hotline_number" @click="bindPhone(scope.$index, scope.row)">绑定400</el-button>   
                        <el-button size="mini"  v-if="scope.row.channel != 1" type="danger" @click="handleChannelDelete(scope.$index, scope.row)">删除</el-button>
                        <el-button size="mini" v-if="scope.row.pc_url" @click="copyPath(scope.row.pc_url)">复制PC竞价链接</el-button>
                        <el-button size="mini" v-if="scope.row.m_url" @click="copyPath(scope.row.m_url)">复制M端竞价链接</el-button>
                       

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="site-btn-list">
            <el-button type="primary" @click="handleSaveSubmit">保 存</el-button>
            <el-button @click="$router.back()">取 消</el-button>
        </div>
        <AddSite ref="siteAddRef" :callback="seatCallback" :size="siteList.length" />
        <AddChannel ref="channelAddRef" :callback="channelCallback"  :channelListA="channelList" />
      
    </div>
</template>
<script>
import AddSite from '../components/addSite'
import AddChannel from '../components/addChannel'

import { getHouseTelephoneList, delHouseSeat, setHouseSeat } from '@/service/housedict'
import { addInvesTelephone , getInvesTelephone } from '@/service/investment'
import { mapGetters } from 'vuex'
import { param } from 'jquery'
export default {
    name: 'HouseSaleAdd',
    components: {
        AddSite,
        AddChannel
    },
    data () {
        return {
            listener: [
                { id: 0, name: '轮询', desc: '平均分配给每个坐席接听，当首次分配的坐席占线或未接状态，再转给下一个坐席' },
                { id: 1, name: '智能ACD', desc: '按当天已发生的通话数量、通话时长、空闲时长这三个情况综合计算出比重大小，先转接给比重最小的，未接通再依次转接' },
                { id: 2, name: '一号通', desc: '按照分机组里设置的先后顺序，每次呼入电话先转给第一个座席，若第一个座席占线或未接状态，系统再呼叫至第二个座席，以此类推' },
                // { id: 3, name: '地区路由', desc: '暂无描述' },
                { id: 4, name: '坐席百分比', desc: '统计该分机号下面最近几天的各个坐席通话量，计算出坐席电话量的百分比，然后按比重排序坐席列表，比重较低的坐席优先接听' },
                { id: 5, name: '顺序', desc: '严格按照轮询顺序，即使上次已转接接通过了。和轮询的区别：轮询，如本次转接顺序为ABC，因为A忙线等原因未接转给了B，下次来电还是转给A；顺序，如本次转接顺序为ABC，因为A忙线等原因未接转给了B，下次来电转给B' }
            ],
            listenerCheck: {},
            siteList: [],
            channelList: [],
            isLoading: false,
            channelArr:[],
        }
    },

    mounted () {
        this.listenerCheck = this.listener[0];
        this.getHotlineData();
    },
    methods: {
        getHotlineData(){
            getInvesTelephone().then((data) => {
               let channel_arr=[];
               data.forEach(el => {
                   channel_arr.push(el.channel)
               });
               this.channelArr=channel_arr;
            })
        },
        openAddSite () {
            if (this.siteList.length >= 10) {
                this.$message({
                    type: 'error',
                    message: '最多添加10个坐席列表'
                })
                return null
            }
            this.$refs.siteAddRef && this.$refs.siteAddRef.openMenu()
        },
        translatePosition (status, index) {
            const newIndex = status ? index - 1 : index + 1
            if (newIndex === -1 || newIndex === this.siteList.length) return null
            this.siteList[index] = this.siteList.splice(newIndex, 1, this.siteList[index])[0]
        },
        deleteArea (index) {
            this.$confirm('删除后解绑该坐席与楼盘的绑定关系，是否确认？', '删除提示', {
                center: 'center'
            }).then(() => {
                this.siteList.splice(index, 1)
            })
        },
        /** 打开坐席编辑 */
        editSeat (data, index) {
            const result = Object.assign({}, {}, data)
            this.$refs.siteAddRef && this.$refs.siteAddRef.openMenu(result, index)
        },
        changeCheckbox () {},
      
        /** 坐席列表回调 */
        seatCallback (list, index) {
            // 判断是否重复电话
            const data = this.siteList.filter((v, b) => {
                const i = list.findIndex(d => (d.staff_phone === v.staff_phone || b === index))
                return i >= 0
            })
            if ((index === null && data.length > 0) || (index !== null && data.length > 1)) {
                this.$message({
                    type: 'error',
                    message: '不能添加重复的坐席电话'
                })
                return null
            }
            if (index === null) {
                this.siteList = this.siteList.concat(list)
            } else {
                this.siteList.splice(index, 1, list[0])
            }          
        },
        /** 推广渠道回调 */
        channelCallback (data,index) {
            if(index==0){
                this.$set(this.channelList, index, data)
            }else{
                this.channelList.push(data)
            }
           
        },
        /** 点击打开推广渠道弹层 */
        openChannel () {
            if (this.siteList.length <= 0) {
                this.$message({
                    type: 'error',
                    message: '请先添加坐席'
                })
                return null
            }
            this.$refs.channelAddRef && 
            (this.$refs.channelAddRef.channelList = this.channelList) &&
            (this.$refs.channelAddRef.channelArr=this.channelArr) &&
            this.$refs.channelAddRef.openMenu()
        },
        /** 点击打开绑定400弹层 */
        bindPhone(index,row){
            if (this.siteList.length <= 0) {
                this.$message({
                    type: 'error',
                    message: '请先添加坐席'
                })
                return null
            }
            const result = Object.assign({}, {}, row)
            this.$refs.bindPublicRef && this.$refs.bindPublicRef.openMenu(result,index)
        },
        /** 删除推广渠道 */
        handleChannelDelete (index, data) {
            if (!data.id && data.channel!==1) {
                this.channelList.splice(index, 1)
                this.$refs.channelAddRef.typeList.push({
                    'id':data.channel,
                    'name':data.channel_name
                })
                return null
            }
            this.$confirm('删除后解除400绑定关系，不可恢复，是否确认？', '删除提示').then(async () => {
                try {
                    await delHouseSeat(data.customer_hotline_id, data.id, {
                        customerHotlineId: data.customer_hotline_id,
                        id: data.id,
                        site_id: this.permission_siteId
                    })
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    })
                    this.$refs.channelAddRef.initList();
                } catch (error) {
                    const message = error.message
                    this.$message({
                        type: 'error',
                        message: message || ''
                    })
                }
            }).catch(() => {})
        },
        /** 复制竞价链接 */
        copyPath (url = '') {
            let oInput = document.createElement('input')
            oInput.value = url
            document.body.appendChild(oInput)
            oInput.select()
            document.execCommand("Copy")
            this.$message({
                message: '复制成功',
                type: 'success'
            });
            oInput.remove()
        },
        
        /** 提交保存请求 */
        async handleSaveSubmit () {
            if(!this.channelList.length){
                 this.$message({
                    type: 'error',
                    message: '推广渠道不能为空'
                })
                return null
            }
            this.submitData=Object.assign([],this.channelList)
            if(!this.submitData[0].hotline_number){
                this.submitData.splice(0, 1)
            }
            if (this.siteList.length == 0 && this.submitData.length > 0) {
                this.$message({
                    type: 'error',
                    message: '至少需绑定一个坐席'
                })
                return null
            }
            if (this.siteList.length >0 && this.submitData.length <= 0) {
                this.$message({
                    type: 'error',
                    message: '推广渠道不能为空'
                })
                return null
            }
            if (!this.sale_id) {
                this.addInfo()
            }
        },
        /** 保存坐席 */
        async addInfo () {
          
            const prams = {
                transfer_mode: this.listenerCheck.id,
                seats: this.siteList,
                telephones: this.submitData
            }
            try {
                await addInvesTelephone(prams)
                this.$message({
                    type: 'success',
                    message: '保存成功'
                })
                this.$router.back()
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: error.message || '保存失败'
                })
            }
        }
        /** 编辑坐席 */
    }
}
</script>
<style>
    .el-tooltip__popper{
        width: 200px!important;
        line-height: 24px!important;
    }
    .floor-sale-container .title{
        padding: 10px;
        margin-top: 20px;
    }
</style>